<template>
  <confirmation-card :title="`${text}?`">
    <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
    <v-btn flat @click="deleteInvoice()" color="red darken-1" :loading="loading">{{text}}</v-btn>
  </confirmation-card>
</template>

<script>
import RctiService from "@/services/requests/rctiService";
import BillService from "@/services/requests/billService";
const services = {
  bill: BillService,
  rcti: RctiService
};
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async deleteInvoice() {
      this.loading = true;
      var methodString = "delete" + this.titleCase(this.invoiceType);
      try {
        if (this.invoiceType == "rcti")
          var result = await RctiService.deleteRcti(this.invoice.id);
        else var result = await BillService.deleteBill(this.invoice.id);

        this.$store.commit(`${this.invoiceType}s/deleteFromArrayStateByValue`, {
          prop: `${this.invoiceType}s`,
          value: this.invoice
        });
        this.snack({ text: "Invoice undone!", color: "green" });
      } catch (err) {
        this.snack({ text: err.response.data.message, color: "red" });
      }
      this.loading = false;
    }
  },
  computed: {},
  props: {
    invoice: Object,
    invoiceType: String,
    text: String
  }
};
</script>

<style>
</style>
